import {Component} from '@angular/core';
import {MENU_PAGE} from '../../shared/defines/desktop.const';
import {WordComponent} from "../word.component";
import {
  HISTORY_KEY_SEARCH_SAJASEUNGEO,
  HISTORY_KEY_VIEW_SAJASEUNGEO,
  SearchParam,
} from "../../shared/defines/client.const";
import {WordBookmarkService} from "../../shared/services/word/word-bookmark.service";
import {SajaseungeoBookmarkService} from "../../shared/services/word/sajaseungeo-bookmark.service";

@Component({
  selector: 'app-sajaseungeo',
  templateUrl: './../word.component.html',
  styleUrls: ['./sajaseungeo.component.scss'],
  providers: [
    {
      provide: WordBookmarkService,
      useClass: SajaseungeoBookmarkService,
    },
  ],
})
export class SajaseungeoComponent extends WordComponent {
  protected override thisPageAddr = '/sajaseungeo';

  protected override historyKeySearch = HISTORY_KEY_SEARCH_SAJASEUNGEO;
  protected override historyKeyView = HISTORY_KEY_VIEW_SAJASEUNGEO;

  protected override jasoIdxSecond = false;

  public override placeholder = '사 자 성어를 검색 합니다.';
  protected override noResultTxt = '사 자 성어가 없습니다.';

  protected override showLevel = false;

  protected override get wordLevelAll(): boolean {
    // 사 자 성어는 모든 난이도를 표시한다.
    return true;
  }


  protected override getMenuPage(): MENU_PAGE {
    return MENU_PAGE.SAJASEUNGEO;
  }

  protected override getBookmarkMenuPage(): MENU_PAGE {
    return MENU_PAGE.SAJASEUNGEO_BOOKMARK;
  }

  protected override modParam(param: SearchParam): SearchParam {
    return {
      ...param,
      saja: 1,
    }
  }

  protected override setLastId(detail_id: string | null, list_id: string | null): void {
    this.lastIdSvc.setLastSajaseungeoId(detail_id, list_id);
  }

  protected override clearLastId(): void {
    this.lastIdSvc.clearLastSajaseungeoId();
  }
}
